
var playerPlaceholder = document.getElementById('player');

if ( playerPlaceholder ) {
	var provider = playerPlaceholder.dataset.provider;

	if ( provider == 'youtube' ) {
		var youtubeId = playerPlaceholder.dataset.youtube;

		playerPlaceholder.innerHTML = '';

		var tag = document.createElement('script');

		tag.src = "https://www.youtube.com/iframe_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
		
		var player;
	}

	if ( provider == 'vimeo' ) {
		var vimeoId = playerPlaceholder.dataset.vimeo;

		playerPlaceholder.innerHTML = '';

		var options = {
			id: vimeoId,
			width: 640,
			loop: false
		};

		var player = new Vimeo.Player('player', options);

		player.on('pause', onVimeoStop);
		player.on('ended', onVimeoStop);
	}

}

function onYouTubeIframeAPIReady() {
	if(youtubeId.indexOf('videoseries') + 1){
		youtubeId = youtubeId.replace("videoseries?list=", "");
		player = new YT.Player('player', {
			height: '360',
			width: '640',
			playerVars: {
				listType: 'playlist',
				list: youtubeId,
				rel: 0
			},
			events: {
				'onStateChange': onYoutubeStop
			}
		});
	} else {
		player = new YT.Player('player', {
			height: '360',
			width: '640',
			videoId: youtubeId,
			playerVars: {
				rel: 0
			},
			events: {
				'onStateChange': onYoutubeStop
			}
		});
	}
}

function onYoutubeStop( event ) {
	if ( event.data == YT.PlayerState.ENDED || event.data == YT.PlayerState.PAUSED ) {
		jQuery('body').removeClass('video-active');
	} else {
		jQuery('body').addClass('video-active');
	}
}

function onVimeoStop(data) {
	jQuery('body').removeClass('video-active');
}

(function($) {
	
	$('.more-videos .series ul').slick({
		infinite: false,
		slidesToShow: 4,
		slidesToScroll: 4,
		variableWidth: true,
		prevArrow: '<i class="fas fa-chevron-left slick-prev"></i>',
		nextArrow: '<i class="fas fa-chevron-right slick-next"></i>',
		responsive: [
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					variableWidth: true,
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					variableWidth: true,
				}
			}
		]
	});

	$('.play-video').on('click', function(event) {
		event.preventDefault();
		
		$('body').addClass('video-active');

		if ( provider == 'youtube' ) {
			player.playVideo();
		}
		if ( provider == 'vimeo' ) {
			player.play();
		}
		if ( provider == 'wistia' ) {
			window._wq = window._wq || [];
			_wq.push({ id: "_all", onReady: function(video) {
				
				video.play();
				video.unmute();

				video.bind("pause", onVimeoStop);
				video.bind("end", onVimeoStop);
			}});
		}
		
	});

})(jQuery);